




import IconSearchEmpty159px from "@/common/components/icons/IconSearchEmpty159px.vue";
import IconSearchEmpty103px from "@/common/components/icons/IconSearchEmpty103px.vue";
import { Prop, Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    IconSearchEmpty159px,
    IconSearchEmpty103px
  }
})
export default class IconSearchEmpty extends Vue {
  @Prop({ type: Number, default: 159 }) iconSize!: number;

  get iconComponent() {
    const { iconSize } = this;
    return `IconSearchEmpty${iconSize}px`;
  }
}
